// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 369) return "static/chunks/369-0921a5240fa84ea5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1082":"01c150364a211cbe","3073":"42cf9ed7a38de7d1","5598":"2847e91e267260bd","7349":"b03be7ad0b8a98ca"}[chunkId] + ".js";
};